import { DwOrmData } from "@devwareapps/devware-cap";

export interface SchoolAssignmentStatEntity extends DwOrmData  { 
    ActiveAssignments: number;
    PastDueAssignments: number;
}

export enum SchoolAssignmentStatAggregateFields {
    ActiveAssignments = 'ActiveAssignments',
    PastDueAssignments= 'PastDueAssignments',
}